// CLIENT PORTAL — "is this a group report?", asked in one place.
//
// ⚠️⚠️ FOUR SURFACES ASKED IT SEPARATELY, each with its own `length <= 1`
// (2026-09-04, round 8 §3). The creative cards' club label, the group growth
// charts, the location picker and — new — whether the audience section exists at
// all. Four copies of a one-line rule agreeing by coincidence is the shape that
// has cost this project three rounds already (round 6's three `'lastYear'`
// literals; round 7's three copies of a render-guard trio).
//
// ⚠️ THE THRESHOLD IS THE WHOLE RULE, so it is stated once: TWO OR MORE
// ACCOUNTS IS A GROUP. A single-location scope is not a group even when the
// login could hold several, because `report.accounts` is POST-NARROWING — a
// drill-down to one club has exactly one account here, and every surface that
// asks this question wants the drill-down treated as the single club it is.
//
// ⚠️ It takes the LIST rather than a count. Every caller already holds the list,
// and a `number` parameter is the shape that lets a caller pass the wrong count
// (the scope's total instead of the narrowed one) with nothing to catch it.

/**
 * Is this report covering more than one account?
 *
 * ⚠️⚠️ WHAT EACH CALLER DOES WITH `true` IS NOT THE SAME THING, and that is
 * deliberate — this answers only "is it a group", never "so hide something":
 *
 * · the creative card LABELS its club (one name per card is noise otherwise)
 * · the group charts EXIST (one line comparing itself to nothing is not a
 *   comparison)
 * · the location picker SHOWS (nothing to pick between below two)
 * · the audience section is OMITTED — because Meta reports per pull window, so
 *   two locations can be answered by two different periods and summing them
 *   mixes grains inside one percentage. Nobody can ever chase that.
 *
 * ⚠️⚠️ THAT LAST ONE IS THE ONE TO BE CAREFUL WITH. A single location's missing
 * audience data is A FAULT SOMEONE SHOULD CHASE — a failed nightly job, or a
 * read that returned `grain: 'none'` with a reason. A group's is STRUCTURAL AND
 * PERMANENT. The two absences must never share a gate: silence on the first is
 * what turned a failed nightly job into four rounds of investigation on
 * 2026-08-31. See `AudiencePanel`, which no longer knows the account count at
 * all so it CANNOT express the group case.
 */
export function isGroupScope(accounts: ReadonlyArray<unknown>): boolean {
  return accounts.length > 1;
}
